import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { dateFormatter } from 'src/services/fetching';
import Label from 'src/components/label';

export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, projectId, index }) {
    const {
        id,
        title,
        description,
        status,
        due_date,
        labels,
        created_at,
        updated_at,
        created_by,
        assigned_users
    } = row;

    return (
        <TableRow hover selected={ selected }>
            <TableCell padding="checkbox">
                <Checkbox checked={ selected } onClick={ onSelectRow } />
            </TableCell>
            <TableCell>{ index }</TableCell>
            <TableCell>{ title }</TableCell>
            <TableCell>{ description }</TableCell>
            <TableCell>
                <Label
                    variant="soft"
                    color={
                        (status === 'active' && 'success') ||
                        (status === 'pending' && 'warning') ||
                        (status === 'banned' && 'error') ||
                        'default'
                    }
                >
                    { status }
                </Label>
            </TableCell>

            <TableCell>
                { assigned_users?.length > 0
                    ? assigned_users?.map((user) => `${user?.first_name} ${user?.last_name}`).join(', ')
                    : 'Unassigned' }
            </TableCell>
            <TableCell>{ due_date }</TableCell>
            <TableCell>
                { Array.isArray(labels)
                    ? labels.join(', ')
                    : JSON.parse(labels || '[]').join(', ') }
            </TableCell>
            <TableCell>{ dateFormatter(created_at) }</TableCell>
            <TableCell>{ dateFormatter(updated_at) }</TableCell>
            <TableCell>
                { created_by ? `${created_by?.first_name} ${created_by?.last_name}` : '' }
            </TableCell>
        </TableRow>
    );
}
UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    projectId: PropTypes.number,
};
